__turbopack_context__.v({
  "questionCardCheckbox": "styles-module-scss-module__oqnF6q__questionCardCheckbox",
  "questionCardCheckbox__card": "styles-module-scss-module__oqnF6q__questionCardCheckbox__card",
  "questionCardCheckbox__error": "styles-module-scss-module__oqnF6q__questionCardCheckbox__error",
  "questionCardCheckbox__errorSlot": "styles-module-scss-module__oqnF6q__questionCardCheckbox__errorSlot",
  "questionCardCheckbox__grid": "styles-module-scss-module__oqnF6q__questionCardCheckbox__grid",
  "questionCardCheckbox__icon": "styles-module-scss-module__oqnF6q__questionCardCheckbox__icon",
  "questionCardCheckbox__input": "styles-module-scss-module__oqnF6q__questionCardCheckbox__input",
  "questionCardCheckbox__label": "styles-module-scss-module__oqnF6q__questionCardCheckbox__label",
});
